export default "__VITE_ASSET__BJQ0EcgT__"